import { render, staticRenderFns } from "./antecedenteObstetricoShow.vue?vue&type=template&id=298e1e86"
import script from "./antecedenteObstetricoShow.vue?vue&type=script&lang=js"
export * from "./antecedenteObstetricoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports